class GigStore {
    constructor(entries) {
        this.mapGigs(entries);
    }

    initialize() {
        console.log('Initializing store.');
        if (this.gigMap)
            this.gigMap.clear();
        else
            this.gigMap = new Map();
        this.gigs = [];
        if (this.entryMap)
            this.entryMap.clear();
        else
            this.entryMap = new Map();
        this.head = null;
        this.tail = null;
    }

    makeGigEntry = (id = null, gig = null, next = null, prev = null) => ({id, gig, next, prev});

    makeGigsArray() {
        this.gigs = [];
        let head = this.head;
        while (head) {
            this.gigs.push(head.gig);
            head = head.next;
        }
    }

    mapEntry(key) {
        if (key && typeof (key) === 'string') {
            return this.entryMap.get(key) || null;
        }
        return key;
    }

    makeList(entries) {
        console.log('makeList:', entries);
        if (entries) {
            [this.head, this.tail] = entries.reduce((last, entry) => {
                // console.log('reduce:', last, entry);
                let [head, tail] = last;
                const {next, prev} = entry;

                if (next) {
                    // console.log('map next:', next);
                    entry.next = this.mapEntry(next);
                    // console.log('mapped:', entry.next);
                } else {
                    // console.log('make tail:', entry);
                    tail = entry;
                    entry.next = null;
                    // console.log('tail:', entry);
                }
                if (prev) {
                    // console.log('map prev:', prev);
                    entry.prev = this.mapEntry(prev);
                    // console.log('mapped:', entry.prev);
                } else {
                    // console.log('make head:', entry);
                    head = entry;
                    entry.prev = null;
                    // console.log('head:', entry);
                }

                return [head, tail];
            }, [null, null])
        }
        console.log(this.head, this.tail);
    }

    mapGigs(entries) {
        // console.log('Mapping:', entries)
        this.initialize();
        const mapped = entries.map(e => {
            const {id, gig, next, prev} = e;
            this.gigMap.set(gig.id, e);
            this.entryMap.set(id, e);
            return e;
        });
        this.makeList(mapped);
        this.makeGigsArray();
        return this.gigs
    }

    mergeUpdates(updates, changes) {
        return {
            ...updates,
            ...changes
        }
    }

    addGig(key, gig) {
        let updates = null;
        // console.log('Add gig:', gig);
        if (!this.gigMap.has(gig.id) && !this.entryMap.has(key)) {
            // console.log('Gig is new')
            const entry = this.makeGigEntry(key, gig, null, null);
            this.gigMap.set(gig.id, entry);
            this.entryMap.set(key, entry);
            updates = this.addEntry(entry);
            // console.log(updates);
        }
        return updates
    }

    removeGig(gid) {
        let updates = null;
        const entry = this.gigMap.get(gid);
        if (entry) {
            updates = this.removeEntry(entry);
            this.gigMap.delete(gid);
            this.entryMap.delete(entry.id);
        }
        return updates;
    }

    moveUp(id) {
        const entry = this.gigMap.get(id);
        let updates = null;
        if (entry && entry.prev) {
            const prev = entry.prev
            updates = this.mergeUpdates(
                this.removeEntry(entry),
                this.insertBefore(entry, prev)
            );
        }
        return updates;
    }

    moveDown(id) {
        const entry = this.gigMap.get(id);
        let updates = null;
        if (entry && entry.next) {
            const next = entry.next
            updates = this.mergeUpdates(
                this.removeEntry(entry),
                this.insertAfter(entry, next)
            );
        }
        return updates;
    }

    moveToTop(id) {
        const entry = this.gigMap.get(id);
        let updates = null;
        if (entry && entry.prev) {
            updates = this.mergeUpdates(
                this.removeEntry(entry),
                this.insertBefore(entry, this.head)
            );
        }
        return updates;
    }

    moveToBottom(id) {
        const entry = this.gigMap.get(id);
        let updates = null;
        if (entry && entry.next) {
            updates = this.mergeUpdates(
                this.removeEntry(entry),
                this.insertAfter(entry, this.tail)
            );
        }
        return updates;
    }

    serializeReference(ref) {
        return ref
            ? typeof(ref) === 'string'
                ? ref
                : ref.id
            : null
    }

    serializeEntry(entry) {
        // console.log('Serializing entry:', entry)
        let result = null;
        if (entry) {
            result = {};
            result.gig = entry.gig;
            result.next = this.serializeReference(entry.next)
            result.prev = this.serializeReference(entry.prev)
        }
        // console.log('Serialized entry:', result)
        return result;
    }

    updatePrev(entry, target, updates) {
        // console.log('Update prev of', entry, 'to', target, 'in', updates);
        entry.prev = target;
        if (entry.id) {
            if (!updates[entry.id]) {
                // console.log('Creating update for', entry)
                updates[entry.id] = this.serializeEntry(entry);
            }
            updates[entry.id].prev = target ? target.id : null; // TODO no longer useful?
        } else {
            console.error('Should not happen')
            // TODO Should not happen
            updates.prev = target ? target.id : null;
        }
        // console.log('After update prev:', updates)
    }

    updateNext(entry, target, updates) {
        // console.log('Update next of', entry, 'to', target, 'in', updates);
        entry.next = target;
        if (entry.id) {
            if (!updates[entry.id]) {
                // console.log('Creating update for', entry)
                updates[entry.id] = this.serializeEntry(entry);
            }
            updates[entry.id].next = target ? target.id : null;
        } else {
            updates.next = target ? target.id : null;
        }
        // console.log('After update next:', updates)
    }

    updateEntry(entry, ptarget, ntarget, updates) {
        this.updatePrev(entry, ptarget, updates);
        this.updateNext(entry, ntarget, updates);
    }

    removeEntry = entry => {
        const updates = {};
        if (entry.prev) this.updateNext(entry.prev, entry.next, updates);
        else this.head = entry.next;
        if (entry.next) this.updatePrev(entry.next, entry.prev, updates);
        else this.tail = entry.prev;
        entry.next = entry.prev = null;
        updates[entry.id] = null;
        return updates;
    }

    addEntry = entry => {
        return this.insertAfter(entry, this.tail);
    }

    insertBefore = (entry, target) => {
        const updates = {};
        if (target) {
            this.updateEntry(entry, target.prev, target, updates);
            if (target.prev) this.updateNext(target.prev, entry, updates);
            else this.head = entry;
            this.updatePrev(target, entry, updates);
        } else if (this.head == null) {
            this.head = this.tail = entry;
            this.updateEntry(entry, null, null, updates);
        }
        return updates;
    }

    insertAfter = (entry, target) => {
        const updates = {};
        if (target) {
            this.updateEntry(entry, target, target.next, updates);
            if (target.next) this.updatePrev(target.next, entry, updates);
            else this.tail = entry;
            this.updateNext(target, entry, updates);
        } else if (this.tail == null) {
            this.head = this.tail = entry;
            this.updateEntry(entry, null, null, updates);
        }
        return updates;
    }
}

export default GigStore;